import useLocalStorage from '@rehooks/local-storage'
import { useAcessoLotacao } from 'components/auth/useAcessoLotacao'
import useSession from 'components/auth/useSession'
import { Breadcrumb } from 'components/breadcrumb'
import { PageLoading } from 'components/loading'
import { PecSwitch } from 'components/route'
import { useAgendamentosDiaQuery, useAtendimentoVacinacaoViewQuery } from 'graphql/hooks.generated'
import { SituacaoAgendado } from 'graphql/types.generated'
import moment from 'moment'
import React from 'react'
import { useRouteMatch } from 'react-router'
import { Redirect, Route } from 'react-router-dom'

import { AtendimentoAntecedentesView } from '../detail/antecedentes/AtendimentoAntecedentesView'
import { AtendimentoHeader } from '../detail/AtendimentoHeader'
import { CidadaoDetailView } from '../detail/cadastro-cidadao/CidadaoDetailView'
import { HistoricoAtendimentoView } from '../detail/historico/HistoricoAtendimentoView'
import { VacinacaoView } from '../detail/vacinacao/VacinacaoView'
import { AtendimentoVacinacaoState } from './model'

interface AtendimentoVacinacaoViewProps {
  atendimentoId: ID
}

export function AtendimentoVacinacaoView(props: AtendimentoVacinacaoViewProps) {
  const { atendimentoId } = props
  const { data: sessao } = useSession()
  const match = useRouteMatch()

  const {
    data: { atendimento },
    loading: loadingAtendimento,
  } = useAtendimentoVacinacaoViewQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      atendimentoId,
    },
  })

  const { unidadeSaude } = useAcessoLotacao()
  const { cidadao, prontuario } = atendimento || {}
  const isLoading = loadingAtendimento

  const [, , deleteCacheState] = useLocalStorage<AtendimentoVacinacaoState>(
    `${sessao.acesso.id}/atendimento/vacinacao/${atendimentoId}` //dúvida
  )

  const { data: agendamentosDiaQueryResults } = useAgendamentosDiaQuery({
    variables: {
      input: {
        cidadao: cidadao?.id,
        dataAgendado: moment().startOf('day').toDate(),
        situacao: [SituacaoAgendado.AGENDADO, SituacaoAgendado.CIDADAO_PRESENTE_NA_UNIDADE],
        unidadeSaude: unidadeSaude.id,
        foraDaUbs: false,
        origemAtencaoDomiciliar: false,
      },
    },
  })
  const agendamentosDia = agendamentosDiaQueryResults?.agendados?.content.filter(
    (agendado) => agendado.id !== atendimento.agendado?.id || agendado?.lotacaoAgendada?.id !== sessao.acesso.id
  )

  const renderVacinacaoView = () => (
    <VacinacaoView
      atendimentoId={atendimentoId}
      prontuarioId={prontuario.id}
      cidadao={cidadao}
      dataAtendimento={atendimento?.iniciadoEm}
      clearCache={deleteCacheState}
      agendamentosDia={agendamentosDia}
      initialValues={
        {
          condicoesVacinacao: {
            gestante: prontuario.gestante,
            puerpera: prontuario.gestante ? false : prontuario.puerpera,
          },
          registroVacinacao: [],
        } as AtendimentoVacinacaoState
      }
    />
  )

  const renderAtendimentoHistoricoView = () => (
    <HistoricoAtendimentoView atendimentoId={atendimentoId} clearCache={deleteCacheState} />
  )

  const renderAtendimentoAntecedentesView = () => (
    <AtendimentoAntecedentesView atendimentoId={atendimentoId} clearCache={deleteCacheState} />
  )

  const renderCidadaoDetail = () => (
    <CidadaoDetailView atendimentoId={atendimentoId} cidadaoId={cidadao?.id} clearCache={deleteCacheState} />
  )

  if (isLoading) {
    return (
      <>
        <Breadcrumb title='Atendimento de vacinação' />
        <PageLoading message='Carregando dados do atendimento de vacinação...' />
      </>
    )
  }

  return (
    <>
      <Breadcrumb title='Atendimento de vacinação' />

      <AtendimentoHeader cidadaoId={cidadao?.id} renderFolhaRosto={false} renderSoap={false} renderVacinacao />
      <PecSwitch>
        <Redirect exact path={match.url} to={`${match.url}/vacinacao`} />
        <Route path={`${match.url}/vacinacao`} render={renderVacinacaoView} />
        <Route path={`${match.url}/historico`} render={renderAtendimentoHistoricoView} />
        <Route path={`${match.url}/antecedentes`} render={renderAtendimentoAntecedentesView} />
        <Route path={`${match.url}/cadastro-cidadao`} render={renderCidadaoDetail} />
      </PecSwitch>
    </>
  )
}
